import React, { useState, useEffect } from 'react'
import selectedIcon from './img/ic-program-selected.svg'
import classes from './index.module.scss'

const styles = classes.styles

const ProgramCard = ({ program, onClick, selected }) => {
  const [isSelected, setIsSelected] = useState(false)

  const handleClick = () => {
    setIsSelected(!isSelected)
    onClick(program)
  }

  useEffect(() => {
    setIsSelected(selected)
  }, [selected])

  return (
    <div className={styles} onClick={handleClick}>
      <div className={`program-card-wrapper ${isSelected ? 'selected' : ''}`}>
        <img
          key={program.coverUrl}
          src={program.coverUrl}
          alt={program.name}
          className='program-card-sec'
        />
        <img
          src={selectedIcon}
          alt='selected'
          className='program-selected-icon'
          hidden={!isSelected}
        />
      </div>
    </div>
  )
}

export default ProgramCard
